const ADMIN_USER_DETAIL_BREADCRUMB_CONSTANT = [
  {
    title: "Users",
    link: "/admin/user_management",
  },
  {
    title: "User Details",
    link: "",
    is_active: true,
  },
];

export default ADMIN_USER_DETAIL_BREADCRUMB_CONSTANT;
